import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { LocalStorageService } from 'src/app/local-storage.service';
import { ServiceProviderAssessmentContactPersonDialogComponent } from '../service-provider-assessment-contact-person-dialog/service-provider-assessment-contact-person-dialog.component';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';

@Component({
  selector: 'app-service-provider-assessment-dialog',
  templateUrl: './service-provider-assessment-dialog.component.html',
  styleUrls: ['./service-provider-assessment-dialog.component.scss']
})
export class ServiceProviderAssessmentDialogComponent implements OnInit {
  isLoading = false;
  firstStep: FormGroup;
  secondStep: FormGroup;
  thirdStep: FormGroup;
  fourthStep: FormGroup;
  fifthStep: FormGroup;
  sixthStep: FormGroup;
  seventhStep: FormGroup;
  eighthStep: FormGroup;
  ninthStep: FormGroup;
  tenthStep: FormGroup;
  eleventhStep: FormGroup;
  isEditMode = false;
  maxDate: Date = new Date(2999, 11, 31);

  @Input() formNumber: any;
  @Input() approved: boolean;
  @Output() handleSubmitData = new EventEmitter();
  @Output() handleSaveChanges = new EventEmitter();
  @Output() handleFormNumberChange = new EventEmitter<number>();
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild('submitButton1') submitButton1;
  @ViewChild('submitButton2') submitButton2;

  subject: any;
  professionalWorkerName: any;
  showDate: any;
  currentDate = new Date();
  isMemberSelected = false;
  selectedMember = null;
  assessmentForm: any = {};

  contactPersons: FormArray;
  @ViewChild('contactPersonTable') contactPersonTable: MatTable<any>;
  contactPersonDataSource: any[] = [];
  displayedContactColumns = ['name', 'kinship', 'address', 'phone', 'email', 'actions'];

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private dialogRef: MatDialogRef<ServiceProviderAssessmentDialogComponent>,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private serviceProviderSubjectService: ServiceProviderSubjectService,
    private toastr: ToastrImplService
  ) { 
    this.showDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.professionalWorkerName = (JSON.parse(this.localStorageService.get('loggedUser'))).firstName + ' ' + (JSON.parse(this.localStorageService.get('loggedUser'))).lastName;
    this.subject = data?.subject;
  }

  ngOnInit(): void {
    this.createForms();
  }

  loadData(data: any) {
    if (!data) {
      this.assessmentForm = {};
  
      this.contactPersons.clear();
      this.contactPersonDataSource = [];
  
      return;
    }
    
    this.assessmentForm = data;
    this.contactPersons.clear();

    if (this.assessmentForm.contactPersons && this.assessmentForm.contactPersons.length > 0) {
      this.assessmentForm.contactPersons.forEach(cp => {
        this.contactPersons.push(
          this.formBuilder.group({
            id: [cp.id],
            name: [cp.name],
            kinship: [cp.kinship],
            address: [cp.address],
            phone: [cp.phone],
            email: [cp.email]
          })
        );
      });
    }
    this.contactPersonDataSource = [...this.contactPersons.controls];
    if (this.contactPersonTable) {
      this.contactPersonTable.renderRows();
    }
    
    this.thirdStep.patchValue({
      familyMembers: this.assessmentForm.familyMembers
    });

    this.fourthStep.patchValue({
      needsAssessment: this.assessmentForm.needsAssessment
    });

    this.fifthStep.patchValue({
      strengthsAssessment: this.assessmentForm.strengthsAssessment
    });

    this.sixthStep.patchValue({
      riskAssessment: this.assessmentForm.riskAssessment
    });

    this.seventhStep.patchValue({
      capacityAssessment: this.assessmentForm.capacityAssessment
    });

    this.eighthStep.patchValue({
      interestAssessment: this.assessmentForm.interestAssessment
    });

    this.ninthStep.patchValue({
      assessmentOfOtherPersonsSignificantToSubject: this.assessmentForm.assessmentOfOtherPersonsSignificantToSubject
    });

    this.tenthStep.patchValue({
      serviceProviderCapacityAssessment: this.assessmentForm.serviceProviderCapacityAssessment
    });

    this.eleventhStep.patchValue({
      conclusion: this.assessmentForm.conclusion
    });

  }

  createForms() {
    this.contactPersons = this.formBuilder.array([]);
    this.firstStep = this.formBuilder.group({
      serviceProvider: [this.subject.serviceProviderName, [Validators.required]],
      dateOfSubmission: [this.showDate, [Validators.required]],
      firstName: [this.subject.firstName, []],
      lastName: [this.subject.lastName, []],
      parentName: [this.subject.parentName, []],
      gender: [this.subject.gender, []],
      dateOfBirth: [this.subject.dateOfBirth, []],
      jmbg: [this.subject.jmbg, []],
      phone: [this.subject.phone, []],
      permanentResidence: [this.subject.permanentResidence, []],
      residence: [this.subject.residence, []],
      nationality: [this.subject.nationality, []],
      citizenship: [this.subject.citizenship, []],
      language: [this.subject.language, []],
      education: [this.subject.education, []],
      employment: [this.subject.employment, []],
      ableToWork: [this.subject.ableToWork, []],
      maritalStatus: [this.subject.maritalStatus, []]
    });

    this.secondStep = this.formBuilder.group({
      contactPersons: this.contactPersons,
    });

    this.thirdStep = this.formBuilder.group({
      familyMembers: ['', []],
    });

    this.fourthStep = this.formBuilder.group({
      needsAssessment: ['', []],
    });

    this.fifthStep = this.formBuilder.group({
      strengthsAssessment: ['', []],
    });

    this.sixthStep = this.formBuilder.group({
      riskAssessment: ['', []],
    });

    this.seventhStep = this.formBuilder.group({
      capacityAssessment: ['', []],
    });

    this.eighthStep = this.formBuilder.group({
      interestAssessment: ['', []],
    });

    this.ninthStep = this.formBuilder.group({
      assessmentOfOtherPersonsSignificantToSubject: ['', []]
    });

    this.tenthStep = this.formBuilder.group({
      serviceProviderCapacityAssessment: ['', []],
    });

    this.eleventhStep = this.formBuilder.group({
      conclusion: ['', []],
    });

    this.serviceProviderSubjectService.getAssessmentForm(this.subject.id).subscribe(result => this.loadData(result));
  }

  addContactPerson() {
    const dialogRef = this.dialog.open(ServiceProviderAssessmentContactPersonDialogComponent, {
      width: '500px',
      disableClose: true,
      data: null,
      panelClass: 'overlay-panel',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.contactPersons.push(
          this.formBuilder.group({
            id: [null],            
            name: [result.name],
            kinship: [result.kinship],
            address: [result.address],
            phone: [result.phone],
            email: [result.email]
          })
        );
        this.contactPersonDataSource = [...this.contactPersons.controls];
        if (this.contactPersonTable) {
          this.contactPersonTable.renderRows();
        }
      }
    });
  }
  
  editContactPerson(index: number) {
    const cp = this.contactPersons.at(index).value;
  
    const dialogRef = this.dialog.open(ServiceProviderAssessmentContactPersonDialogComponent, {
      width: '500px',
      disableClose: true,
      data: cp,
      panelClass: 'overlay-panel',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const existingId = this.contactPersons.at(index).value.id;
        this.contactPersons.at(index).patchValue({
          id: existingId,
          name: result.name,
          kinship: result.kinship,
          address: result.address,
          phone: result.phone,
          email: result.email
        });
        this.contactPersonDataSource = [...this.contactPersons.controls];
        this.contactPersonTable.renderRows();
      }
    });
  }
  
  removeContactPerson(index: number) {
    this.contactPersons.removeAt(index);
    this.contactPersonDataSource = [...this.contactPersons.controls];
    this.contactPersonTable.renderRows();
  }

  preview(){        
    const submittedData = this.createObject(false);
    this.serviceProviderSubjectService.previewAssessmentForm(submittedData);
  }

  createObject(isFinished: boolean){
    const submittedData = {
      id: (this.assessmentForm?.id !== null && this.assessmentForm?.id !== undefined) ? this.assessmentForm?.id : null,
      dateOfSubmission: this.firstStep.value.dateOfSubmission,
      serviceProviderId: this.subject.serviceProviderId,
      serviceProviderSubjectId: this.subject.id,
      contactPersons: this.contactPersons.value.map(cp => ({
        id: cp.id ?? null,
        name: cp.name,
        kinship: cp.kinship ?? null,
        address: cp.address,
        phone: cp.phone,
        email: cp.email
      })),
      familyMembers: this.thirdStep.value.familyMembers,
      needsAssessment: this.fourthStep.value.needsAssessment,
      strengthsAssessment: this.fifthStep.value.strengthsAssessment,
      riskAssessment: this.sixthStep.value.riskAssessment,
      capacityAssessment: this.seventhStep.value.capacityAssessment,
      interestAssessment: this.eighthStep.value.interestAssessment,
      assessmentOfOtherPersonsSignificantToSubject: this.ninthStep.value.assessmentOfOtherPersonsSignificantToSubject,
      serviceProviderCapacityAssessment: this.tenthStep.value.serviceProviderCapacityAssessment,
      conclusion: this.eleventhStep.value.conclusion,
      professionalWorkerName: this.professionalWorkerName,
      finished: isFinished,
    };
    return submittedData;
  }

  save(isFinished: any) {
    const submittedData = this.createObject(isFinished);
    this.serviceProviderSubjectService.submitAssessmentForm(submittedData).subscribe(
      (result) => {
        if (isFinished) {
          this.toastr.success('SERVICE_PROVIDERS.ASSESSMENT_FORM.GENERATE_SUCCESS');
          this.handleSaveChanges.emit({ step: 'STEP_02', isFinished: true, saved: true });
        } else {
          this.toastr.success('VS.INITIAL_ASSESSMENT.FORMS23.SAVED');
          this.handleSaveChanges.emit({ step: 'STEP_02', isFinished: false, saved: true });
        }
        this.dialogRef.close(result);
      }, () => {
        this.submitButton1.disabled = false;
        this.submitButton2.disabled = false;
        this.toastr.error('SNACKBAR.ERROR_OCCURRED');
      }
    );
  }

  handleSubmit() {
    this.submitButton1.disabled = true;
    this.submitButton2.disabled = true;
    this.save(true);
  }

  closeForm() {
    this.isEditMode = false;
    this.dialogRef.close();
  }

}
